import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Utils } from 'src/app/common/utils';
import { TareasApiService } from 'src/app/service/api/tareas-api.service';
import { DashboardService } from 'src/app/service/events/dashboard.service';
import { StorageManager } from '../../../../common/storage-manager.class';
import { Filtering } from 'src/app/service/filtering/filtering';
import { BaseView } from 'src/app/view/base-view';
import { environment } from 'src/environments/environment';
import { InputType, ItemInterface } from 'src/app/common/components/form-builder/form-builder.component';
import { AppFormRequest } from 'src/app/view/app-common/form-request/app-form-request';
import { createCsv } from 'src/app/common/createCsv';
import { RequestHandler } from 'src/app/service/OffService/request-handler';
import { RequestButtonTypes } from 'src/app/common/components/request-button/request-button.component';
import { EcorregimenModel } from 'src/app/models/tareas/ecorregimen.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';

@Component({
    selector: 'app-ecorregimenes',
    standalone: false,
    templateUrl: './ecorregimenes.component.html',
    styleUrls: ['./ecorregimenes.component.scss']
})
export class EcorregimenesComponent extends BaseView<EcorregimenModel> {
    
    public showTareasBioExportCsv = environment.features.showTareasBioExportCsv;
    public appName = environment.appName;
    public applicationType = environment.features.applicationType;
    public rolUser = StorageManager.getUser().rol;
    public userCanSeeClientes = environment.features.userCanSeeClientes;
    public getRequest = this.tareasApi.ecorregimenes.GET;
    public filter: Filtering<EcorregimenModel> = new Filtering<EcorregimenModel>();
    public fincaName = environment.features.fincaName;
    public sectorName = environment.features.sectorName;
    public parcelaName = environment.features.parcelaName;

    public deleteRequest: RequestHandler<EcorregimenModel> = this.tareasApi.ecorregimenes.DELETE;
    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;



    public pathToForm = 'tareas-crear-ecorregimen';
    public pathToEdit = 'tareas-editar-ecorregimen';
    public pathToDuplicate = 'tareas-duplicar-ecorregimen';

    public formRequest = new AppFormRequest<EcorregimenModel>();

    public cols: ColInterface[] = [
        { field: 'parcelas', header: this.parcelaName },
        { field: 'fecha_entrada', header: 'Entrada Agua' },
        { field: 'fecha_salida', header: 'Salida Agua' },
        { field: 'fecha_seca_cultivo_agua', header: 'Inicio Inundación' },
        { field: 'fecha_fin_inundacion_invernal', header: 'Fin Inundación'  },
        { field: 'fecha_seca_arroz', header: 'Seca Arroz' },
        { field: 'fecha_recoleccion_rastrojo', header: 'Recolección' },
        { field: 'operacion_paja', header: 'Operación' },
        { field: 'fecha_operacion', header: 'Fecha Operación' },
        { field: 'hora_inicio', header: 'Inicio Quema' },
        { field: 'hora_fin', header: 'Fin Quema' },
    ];

    colsAva : ColInterface[] = [
        { field: 'finca', header: this.fincaName },
        { field: 'sectores', header: this.sectorName },
        { field: 'parcelas', header: this.parcelaName },
        { field: 'fecha_siembra', header: 'Fecha Siembra' },
        { field: 'dosis_siembra', header: 'Dosis Siembra' },
        { field: 'fecha_recoleccion_arroz', header: 'Fecha Recolección' },
        { field: 'fecha_nivelacion', header: 'Fecha Nivelación' },
        { field: 'fecha_malashierbas', header: 'Fecha Malas Hierbas' },
        { field: 'tareas_malashierbas', header: 'Tareas Malas Hierbas' },
        { field: 'control_mecanico_vn', header: 'Control vegetación palustre' }
    ];

    public formFields: ItemInterface<object>[] = [
        { 
            field: 'finca', 
            name: this.fincaName, 
            label: this.fincaName, 
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'sector', 
            name: this.sectorName, 
            label: this.sectorName, 
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'parcelas', 
            name: this.parcelaName, 
            label: this.parcelaName, 
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'fecha_entrada', 
            name: 'Fecha Entrada', 
            label: 'Fecha Entrada', 
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'fecha_salida', 
            name: 'Fecha Salida', 
            label: 'Fecha Salida', 
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'fecha_seca_cultivo_agua', 
            name: 'Fecha Inundación', 
            label: 'Fecha Inundación', 
            inputType: {type: InputType.TEXT }

        },
        { 
            field: 'fecha_seca_arroz', 
            name: 'Fecha Seca Arroz', 
            label: 'Fecha Seca Arroz', 
            inputType: {type: InputType.TEXT} 
        }
    ];

    public formFieldsRastrojo: ItemInterface<object>[] = [
        { 
            field: 'fecha_recoleccion_rastrojo', 
            name: 'Fecha Recoleccción Rastrojo', 
            label: 'Fecha Recoleccción Rastrojo',
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'operacion_paja', 
            name: 'Operación', 
            label: 'Operación', 
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'fecha_operacion', 
            name: 'Fecha Operación', 
            label: 'Fecha Operación',
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'hora_inicio', 
            name: 'Hora Inicio', 
            label: 'Hora Inicio',
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'hora_fin', 
            name: 'Hora Fin', 
            label: 'Hora Fin',
            inputType: {type: InputType.TEXT} 
        },
        { 
            field: 'horas_totales', 
            name: 'Hora Totales', 
            label: 'Hora Totales',
            inputType: {type: InputType.TEXT},
            visible: this.applicationType !== 'cropgest' 
        },
    ];

    constructor(dashboard: DashboardService,
        private router: Router,
        private tareasApi: TareasApiService){
        super(
            dashboard,
            tareasApi.ecorregimenes.GET,
            tareasApi.ecorregimenes.DELETE
        );
    }

    public add() {
        this.router.navigate(['dashboard', this.pathToForm]);
    }

    public edit(data: EcorregimenModel) {
        this.router.navigate(['dashboard', this.pathToEdit , data.id]);
    }

    public duplicate(data: EcorregimenModel) {
        this.router.navigate(['dashboard', this.pathToDuplicate , data.id]);
    }

    public override deleteRegister() {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    public globalConditionalStyle(_value: string, _col: ColInterface): ColStylesInterface {
        return {textAlign: 'center'};
    }

    public downloadCsv(): void {
  
        const arrayFormFields = [
            this.formFields,
            this.formFieldsRastrojo
        ];

        const csvContent = createCsv(arrayFormFields, this.filter.value, 'fecha_operacion');

        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = 'Tareas ecorregimenes.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<EcorregimenModel>) {
        const ecorregimen = row.data as EcorregimenModel;

        if (col.field === 'control_mecanico_vn') {
            return ecorregimen.control_mecanico_vn === '1' ? 'Sí' : 'No';
        }

        if (col.field === 'dosis_siembra') {
            if (Utils.isNumber(value)) {
                return Utils.decimalFormat(value);
            }
        }


        if (Utils.isNumber(value) && col.field !== 'finca') {
            // formato decimal y millar
            return Utils.decimalFormat(value, 2, '.', ',', 3);
        }

        if (col.field === 'parcelas') {
            const str = Utils.replaceAll(Utils.replaceAll((ecorregimen[col.field] || ''), '- ', ''), '\n', '\n, ');
            value = str.substring(0, str.length - 2);
            return (value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }
    

        if (col.field === 'sectores_nombres') {
            const str = Utils.replaceAll(Utils.replaceAll((ecorregimen[col.field] || '' ), '- ', ''), '\n', '\n, ');
            return str.substring(0, str.length - 2);
        
        }

        return value;
    }

}
